import React from 'react';
import useAuthUser from 'src/hooks/useAuthUser';
import PageWrapper from 'src/components/PageWrapper';
import { Route, Switch } from 'react-router-dom/';
import CopilotCategorization from 'src/components/Copilot/CopilotCategorization';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import PropTypes from 'prop-types';
import theme from 'src/config/theme';
import CopilotPrioritization from 'src/components/Copilot/CopilotPrioritization';
import CopilotPrioritizationOld from 'src/components/CopilotPrioritization';

const Copilot = ({ match }) => {
  const { featureFlags, company } = useAuthUser();
  const isCopilotEnabled = featureFlags.includes('copilot');
  const isCategorizationEnabled = featureFlags.includes('copilot_categorization');
  const shouldUseNewPrioritization = featureFlags.includes('new_copilot_prioritization');
  const tabs = [
    { id: 1, path: `${match.url}/prioritization`, name: 'Prioritization' },
    ...(isCategorizationEnabled
      ? [{ id: 2, path: `${match.url}/categorization`, name: 'Categorization' }]
      : [])
  ];

  if (!isCopilotEnabled) {
    return '';
  }

  return (
    <PageWrapper
      title="Magic AI"
      tabs={tabs}
      padding={0}
      backgroundColor={theme.colors.common.white}
    >
      <Switch>
        <Redirect exact from={match.path} to={`${match.path}/prioritization`} />
        <Route
          path={`${match.path}/prioritization`}
          render={() =>
            shouldUseNewPrioritization ? (
              <CopilotPrioritization companyId={company.id} />
            ) : (
              <CopilotPrioritizationOld companyId={company.id} />
            )
          }
        />
        {isCategorizationEnabled && (
          <Route
            path={`${match.path}/categorization`}
            render={() => <CopilotCategorization companyId={company.id} />}
          />
        )}
      </Switch>
    </PageWrapper>
  );
};

Copilot.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
    path: PropTypes.string
  }).isRequired
};

export default Copilot;
